import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { ContactSaveRequest } from "../types/contact";
import { ContactUpdateInquiryWithContactResource } from "../types/contactUpdateInquiry";

export const contactUpdateForContactKey = (contactUpdateId: Id, contactId: Id) => [
	"contact-update",
	`${contactUpdateId}`,
	`${contactId}`,
];

export const contactUpdateInquiryService = {
	contactUpdateForContactKey,
	getContactUpdateForContact: (contactUpdateId: Id, contactId: Id) =>
		axios.get<LaravelResponse<ContactUpdateInquiryWithContactResource>>(
			keyToUrl(contactUpdateForContactKey(contactUpdateId, contactId)),
		),
	createContactUpdateForContact: (contactUpdateId: Id, contactId: Id, request: ContactSaveRequest) =>
		axios.post<LaravelResponse<ContactUpdateInquiryWithContactResource>>(
			keyToUrl(contactUpdateForContactKey(contactUpdateId, contactId)),
			request,
		),
	createDeletionRequestForContact: (contactUpdateId: Id, contactId: Id) =>
		axios.post<LaravelResponse<ContactUpdateInquiryWithContactResource>>(
			keyToUrl([...contactUpdateForContactKey(contactUpdateId, contactId), "deletion-request"]),
		),
};

export const useContactUpdateForContact = (contactUpdateId: Id, contactId: Id) => {
	const { data: contactUpdate, isLoading } = useQuery({
		queryKey: contactUpdateForContactKey(contactUpdateId, contactId),
		queryFn: () =>
			contactUpdateInquiryService.getContactUpdateForContact(contactUpdateId, contactId).then((res) => res.data.data),
	});

	return {
		contactUpdate,
		isLoading,
	};
};
